import { useFormik } from "formik";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { classNames } from "primereact/utils";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Confetti from "react-confetti";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useWindowSize from "react-use/lib/useWindowSize";
import * as globalUtils from "../../../../helpers/utils";
import {
  setLoading,
  updateBundleQuotation,
  updateFlightProposal,
  updateFlightQuotation,
  updateSelectedFeatures,
  updateTravelDetails,
  updateTravelGoogleTaggingData,
  updateTravelProposal,
  updateTravelQuotation,
} from "../../../../redux/actions/travel";
import ProductCard from "../../components/ProductCard";
import travelConfig from "../../helpers/config";
import * as utils from "../../helpers/utils";

import FlightDelay from "../../components/FlightDelay/flightDelay";

import { ReactComponent as HomeInsuranceIcon } from "../../../../assets/images/home-insurance.svg";
import { ReactComponent as CovidIcon } from "../../../../assets/images/insurance-covid.svg";
import { ReactComponent as TravelIcon } from "../../../../assets/images/schengen.svg";
import { ReactComponent as WinterSportsIcon } from "../../../../assets/images/winter-sports.svg";
import { TravelInsuranceDetailsStyleWrapper } from "./style";

import travel from "../../../../assets/images/travel.svg";

import moment from "moment";
import IbanInput from "../../../../_shared/IbanInput/IbanInput";
import SubFooter from "../../../../_shared/subFooter/subFooter";
import { submitCRMCampaignApi } from "../../../../services/crmApi";
import * as travelService from "../../../../services/travel-service";
import CoveragePopup from "../../components/CoveragePopUp/coveragePopUp";
import DiscountPopup from "../../components/DiscountPopup/DiscountPopup";
import PromoCode from "../../components/PromoCode/promoCode";

const TravelInsuranceDetails = (props) => {
  const { t, i18n } = props;
  const dispatch = useDispatch();
  const toast = useRef(null);
  const navigate = useNavigate();
  const travelProposal = useSelector((state) => state.travel.travelProposal);
  const applicants = useSelector((state) => state.travel.applicants);
  const travelDetails = useSelector((state) => state.travel.travelDetails);
  const flightProposal = useSelector((state) => state.travel.flightProposal);
  const flightCovered = useSelector((state) => state.travel.flightCovered);
  const proposalRequest = useSelector((state) => state.travel.proposalRequest);
  const selectedFeatures = useSelector(
    (state) => state.travel.selectedFeatures
  );
  const { travelGoogleTaggingData, businessLine } = useSelector(
    (state) => state.travel
  );

  const [selectedProductCode, setSelectedProductCode] = useState(
    travelDetails.productCode
  );
  const [features, setFeatures] = useState([]);
  const [showFlightDelay, updateFlightDelay] = useState(false);
  const [showDiscount, setShowDiscount] = useState(false);
  const [disableChangeFlightDetails, setDisableChangeFlightDetails] =
    useState(false);
  const [disableFlight, setDisableFlight] = useState(
    !travelDetails.flightNumber
  );
  const [flightPrice, setFlightPrice] = useState(null);
  const [showCoverageDetails, setShowCoverageDetails] = useState(false);
  const [alfursanCode, setAlfursanCode] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const location = useLocation();
  const [promoCodeFlag, setPromoCodeFlag] = useState();
  const [homeInsurance, setHomeInsurance] = useState(false);
  const currentLanguageCode = i18n.language || "en";

  const homeInsuranceObject = {
    featureCode: "",
    featureDescription:
      currentLanguageCode === "ar" ? "تأمين على المساكن" : "Home Insurance",
    price: "",
    isHomeInsurance: true,
    changeHomeInsurance: (val) => {
      setHomeInsurance(val);
      getTravelProposal(travelDetails, val, businessLine);
    },
  };

  useEffect(() => {
    getFeatures(currentLanguageCode);
  }, [currentLanguageCode]);

  const getFeatures = useCallback((lang) => {
    const request = { ...proposalRequest };

    request.featureCode = "005";
    request.languageCode = lang === "ar" ? "A" : "E";
    request.duration = request.duration.toString();
    dispatch(setLoading(true));
    request.isTpremium =
      travelDetails.productCode === "US" && proposalRequest.duration <= 180
        ? "Y"
        : "N";
    travelService.getTravelFeatures(request, businessLine).then((response) => {
      dispatch(setLoading(false));
      if (response.data.FeatureDescription) {
        let featArray = [...response?.data?.FeatureDescription];
        homeInsuranceObject.featureDescription =
          lang === "ar" ? "تأمين على المساكن" : "Home Insurance";
        if (
          travelDetails.productCode === "US" &&
          proposalRequest.duration <= 180
        )
          featArray.unshift(homeInsuranceObject);
        setFeatures(featArray);
      }
    });
  }, []);

  const getFlightProposal = useCallback(
    (flightDetails) => {
      dispatch(setLoading(true));
      travelService
        .getFlightProposal(
          utils.buildFlightProposalRequest(
            { ...travelDetails, ...flightDetails, applicants: applicants },
            props.i18n.language
          )
        )
        .then((response) => {
          dispatch(setLoading(false));
          if (response.data.resultCode === "S") {
            dispatch(updateFlightProposal(response.data));
          } else {
            toast.current.show({
              severity: "error",
              details: response.data.resultMessage,
            });
          }
        });
    },
    [travelDetails, applicants, props.i18n.language]
  );

  const getFlightDetails = useCallback(() => {
    const obj = {
      applicationRef: "SPFD",
      departureDate: moment(travelDetails.deptDate).format("DD/MM/YYYY"),
      flightNumber: travelDetails.flightNumber,
      lang: props.i18n.language,
    };
    dispatch(setLoading(true));
    travelService.getFlightDetails(obj).then((response) => {
      dispatch(setLoading(false));
      if (response.data.resultCode === "S") {
        setDisableFlight(false);
        getFlightProposal(response.data.flightList[0]);
      } else {
        setDisableFlight(true);
        toast.current.show({
          severity: "error",
          detail: response.data.resultMessage,
          life: 10000,
        });
        if (response.data.resultCode === "V") {
          setDisableChangeFlightDetails(true);
        }
      }
    });
  }, [travelDetails, props.i18n.language, getFlightProposal]);

  useEffect(() => {
    // window.lmSMTObj.page(location.pathname, {
    //   path: location.pathname,
    //   language: globalUtils.isArabic(i18n.language) ? "Arabic" : "English",
    //   referrer: document.referrer,
    //   title: document.title,
    //   url: document.URL,
    //   search: "",
    // });
    // window.scrollTo(0, 0);
    dispatch(updateSelectedFeatures([]));
    // for Google tagging (when user lands on this page)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_quote",
      ecommerce: {
        funnel_step: "step_6",
        step_name: "travel_insurance_new_generate_quote",
        items: [
          {
            item_name: "Travel Insurance New",
            item_category: "PNC Insurance",
            item_class: "Individual",
            travelling_to: travelGoogleTaggingData.travelling_to || "",
            coverage_type: travelGoogleTaggingData.travelling_to || "",
            departure_date: travelDetails.deptDate,
            return_date: travelDetails.returnDate,
          },
        ],
      },
      event: "travel_new_policyCoverageBegin_v2",
      item_name: "Travel Insurance New",
      item_category: "Travel Insurance",
      item_class: "Individual",
      funnel_step: "step_5",
      travelling_to: travelGoogleTaggingData.travelling_to || "",
    });
    if (
      travelDetails?.productCode === "US" &&
      proposalRequest.duration <= 180
    ) {
      dispatch(updateSelectedFeatures([homeInsuranceObject]));
      getTravelProposal(travelDetails, true, businessLine);
      setHomeInsurance(true);
    }
  }, []);

  useEffect(() => {
    if (travelDetails.flightNumber) {
      getFlightDetails();
    }
    getFeatures(currentLanguageCode);
  }, [travelDetails]);

  const getTotalPrice = useCallback(() => {
    if (travelDetails.productCode != selectedProductCode) {
      travelDetails.productCode = selectedProductCode;
      dispatch(updateTravelDetails(travelDetails));
    }
    switch (selectedProductCode) {
      case "FD":
        return getFlightDelayPrice();
      case "TR-FD":
        return getSalesBundlePrice();
      case "TR-CD":
        return getCovidBundlePrice();
      default:
        return getTravelPrice();
    }
  }, [selectedProductCode]);

  const getFlightPrice = useCallback(() => {
    if (flightProposal && flightProposal.quoteList) {
      const coveredFlightItem = flightProposal.quoteList.find(
        (ele) => ele.periodCovered == flightCovered
      );
      if (coveredFlightItem) {
        const priceItem = coveredFlightItem.paymentDetails.find(
          (ele) => ele.amountType === "GRNDTOT"
        );
        return priceItem.amountValue;
      }
      return null;
    }
    return null;
  }, [flightProposal, flightCovered]);

  const isSelectedFeature = (code) => {
    return !!selectedFeatures.find((ele) => ele.featureCode === code);
  };
  const selectFeature = (feature) => {
    let mySelectedFeatures = [...selectedFeatures];
    if (isSelectedFeature(feature.featureCode)) {
      mySelectedFeatures = mySelectedFeatures.filter(
        (f) => f.featureCode != feature.featureCode
      );
    } else {
      mySelectedFeatures.push(feature);
    }
    dispatch(updateSelectedFeatures(mySelectedFeatures));
  };

  const getTravelOriginalPrice = (isFeature = false) => {
    if (isFeature) {
      let totalPremium = 0,
        vatAmount = 0,
        total = +travelProposal.PriceDetails[0].totalPremimum;
      selectedFeatures.map((f) => {
        switch (f.featureCode) {
          case "005":
            totalPremium += +f.price;
            break;
          case "001":
            totalPremium += +f.price; //+travelProposal.PriceDetails[0].totalPremimum;
            break;
          default:
            break;
        }
      });
      total += +totalPremium + +travelProposal.PriceDetails[0].adminFee;
      vatAmount =
        +total * (+travelProposal.PriceDetails[0].VATPercentage / 100);
      return Number(+total + +vatAmount).toFixed(2);
    }
    return Number(travelProposal.PriceDetails[0].GrandTotal).toFixed(2);
  };
  const getTravelPrice = () => {
    const originalPrice = getTravelOriginalPrice();
    // return Number(+originalPrice + +originalPrice * 0.05).toFixed(2);
    const sum = selectedFeatures.reduce(
      (partialSum, a) => +partialSum + +a.price,
      0
    );
    if (sum === 0) return Number(originalPrice).toFixed(2);
    const finalTotal = sum * 1.15 + +originalPrice;
    return finalTotal.toFixed(2);
  };

  const getFlightDelayPrice = () => {
    return Number(+flightPrice + +flightPrice * 0.05).toFixed(2);
  };

  const getPreSalesBundlePrice = () => {
    return Number(+getTravelPrice() + +getFlightDelayPrice()).toFixed(2);
  };

  const getCovidPrice = () => {
    let covidPrice = 0;
    features.map((f) => {
      f.featureCode === "005" && (covidPrice = +f.price);
    });
    covidPrice = vatablePriceFeature(covidPrice);
    return Number(covidPrice).toFixed(2);
  };

  const getCovidBundlePrice = () => {
    return Number(+getTravelPrice() + +getCovidPrice()).toFixed(2);
  };

  const getSalesBundlePrice = () => {
    return Number(+flightPrice + +getTravelOriginalPrice()).toFixed(2);
  };

  const vatablePriceFeature = (price) => {
    return Number(price) + Number(price) * 0.15;
  };
  const getTotalPriceSelectedFeatures = () => {
    if (!selectedFeatures || !selectedFeatures.length) {
      return 0;
    }

    const total = selectedFeatures.reduce(
      (total, item) => (total += vatablePriceFeature(item.price)),
      0
    );
    return Number(total).toFixed(2);
  };

  useEffect(() => {
    const price = getFlightPrice();
    if (price) {
      setFlightPrice(price);
      setDisableFlight(false);
    } else {
      setDisableFlight(true);
    }
  }, [getFlightPrice]);

  const updateAlfursanId = (alfursan) => {
    travelDetails["alfursanId"] = alfursan;
    setAlfursanCode(alfursan);
    dispatch(updateTravelDetails(travelDetails));
  };

  const updatePromoCode = (promoCode) => {
    if (
      (promoCode || travelDetails.promoCode) &&
      travelDetails.promoCode != promoCode
    ) {
      travelDetails["promoCode"] = promoCode;
      dispatch(updateTravelDetails(travelDetails));
      getTravelProposal(travelDetails, false, businessLine);
      setCouponCode(promoCode);
    }
  };

  const getTravelProposal = (travelDetails, homeInsuranceVal, businessLine) => {
    dispatch(setLoading(true));
    travelService
      .getTravelProposal(
        utils.buildTravelProposalRequest(
          { travelDetails, applicants },
          props.i18n.language,
          homeInsuranceVal
        ),
        businessLine
      )
      .then((response) => {
        dispatch(setLoading(false));
        if (response.data.status == "SUCCESS" || response.data.status == "S") {
          dispatch(updateTravelProposal(response.data));
        } else {
          toast.current.show({
            severity: "error",
            detail: response.data.resultMessage,
          });
        }
      });
  };

  const goToPayment = async () => {
    // for Google tagging (after selecting a product)
    const fursan_mempership = Boolean(alfursanCode.length) ? "Yes" : "No";
    const itemPrice = Number(
      selectedFeatures && selectedFeatures.length
        ? +getTravelOriginalPrice(true)
        : +getTotalPrice()
    ).toFixed(2);
    let itemName = "";
    if (selectedProductCode === "TR-CD")
      itemName = "Travel Insurance + Covid 19 Coverage";
    else if (selectedProductCode === "FD") itemName = "Flight Delay";
    else if (selectedProductCode === "TR-FD")
      itemName = "Travel Insurance + Flight Delay";
    else itemName = "Travel Insurance";

    dispatch(
      updateTravelGoogleTaggingData({
        fursan_mempership,
        itemName,
        itemPrice,
        coupon: couponCode,
        travelling_to_sub_id: selectedProductCode,
      })
    );
    if (selectedProductCode == "FD") {
      createFlightQoutation();
    } else if (selectedProductCode == "TR-FD") {
      createBundleQoutation();
    } else if (selectedProductCode == "TR-CD") {
      createCovidBundleQoutation();
    } else {
      createTravelQoutation();
    }
  };

  const createTravelQoutation = () => {
    dispatch(setLoading(true));
    travelService
      .createTravelQoutation(
        utils.buildTravelQoutationRequest(
          { travelDetails, applicants, selectedFeatures },
          props.i18n.language,
          homeInsurance,
          businessLine,
          proposalRequest.duration
        ),
        businessLine
      )
      .then((response) => {
        dispatch(setLoading(false));

        if (response.data.Status == "Success") {
          submitCRMCampaignApi(response.data.QuotationNumber, "TI");
          dispatch(updateTravelQuotation(response.data));
          dispatch(
            updateTravelGoogleTaggingData({
              tax: response.data.VATAmount,
            })
          );
          localStorage.setItem(
            "travelQuotation",
            JSON.stringify(response.data)
          );
          localStorage.setItem("travelDetails", JSON.stringify(travelDetails))
          setShowDiscount(true);
          // navigate("/travel/payment", { replace: true });
          navigate(
            Boolean(businessLine)
              ? `/${businessLine}/travel/payment`
              : "/travel/payment",
            { replace: true }
          );
        } else {
          // for Google tagging (failed to proceed to payment)
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: "Travel Insurance New",
            funnel_step: "step_7",
            error_messages: response.data.ResultMessage,
          });
          toast.current.show({
            severity: "error",
            detail: response.data.ResultMessage,
          });
        }
      })
      .catch((err) => {
        // for Google tagging (failed to proceed to payment)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: "Travel Insurance New",
          funnel_step: "step_7",
          error_messages: JSON.stringify(err),
        });
      })
      .finally((err) => {
        dispatch(setLoading(false));
      });
  };

  const createFlightQoutation = () => {
    dispatch(setLoading(true));
    travelService
      .createFlightQoutation(
        utils.buildFlightQoutationRequest(
          { travelDetails, flightProposal, applicants, flightCovered },
          props.i18n.language
        )
      )
      .then((response) => {
        dispatch(setLoading(false));
        if (response.data.resultCode == "S") {
          dispatch(updateFlightQuotation(response.data));
          localStorage.setItem(
            "travelQuotation",
            JSON.stringify(response.data)
          );
          setShowDiscount(true);
          // navigate("/travel/payment", { replace: true });
          navigate(
            Boolean(businessLine)
              ? `/${businessLine}/travel/payment`
              : "/travel/payment",
            { replace: true }
          );
        } else {
          toast.current.show({
            severity: "error",
            detail: response.data.resultMessage,
          });
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };

  const createBundleQoutation = () => {
    dispatch(setLoading(true));
    Promise.allSettled([
      travelService.createFlightQoutation(
        utils.buildFlightQoutationRequest(
          { travelDetails, flightProposal, applicants, flightCovered },
          props.i18n.language
        )
      ),
      travelService.createTravelQoutation(
        utils.buildTravelQoutationRequest(
          { travelDetails, applicants, selectedFeatures },
          props.i18n.language
        )
      ),
    ]).then((result) => {
      dispatch(setLoading(false));
      submitCRMCampaignApi(result?.data?.QuotationNumber, "TI");
      const [flightQuotationResp, travelQuotationResp] = result;
      if (
        flightQuotationResp.status != "fulfilled" ||
        travelQuotationResp.status != "fulfilled"
      ) {
        dispatch(setLoading(false));
        toast.current.show({
          severity: "error",
          detail: props.t("something-error"),
        });
      } else {
        travelService
          .createMultiPolicySinglePayment(
            utils.buildBundleQoutationRequest(
              travelDetails,
              flightQuotationResp.value.data,
              travelQuotationResp.value.data
            ),
            businessLine
          )
          .then((response) => {
            dispatch(setLoading(false));
            if (response.data.resultCode == "S") {
              dispatch(updateFlightQuotation(flightQuotationResp.value.data));
              localStorage.setItem(
                "flightDelayQuotation",
                JSON.stringify(flightQuotationResp.value.data)
              );
              dispatch(updateTravelQuotation(travelQuotationResp.value.data));
              localStorage.setItem(
                "travelQuotation",
                JSON.stringify(travelQuotationResp.value.data)
              );
              dispatch(updateBundleQuotation(response.data));
              // navigate("/travel/payment", { replace: true });
              navigate(
                Boolean(businessLine)
                  ? `/${businessLine}/travel/payment`
                  : "/travel/payment",
                { replace: true }
              );
            } else {
              toast.current.show({
                severity: "error",
                detail: props.t("something-error"),
              });
            }
          });
      }
    });
  };

  const createCovidBundleQoutation = () => {
    dispatch(setLoading(true));
    const featuresList = [...selectedFeatures];
    featuresList.push(features.find((f) => f.featureCode === "005"));
    travelService
      .createTravelQoutation(
        utils.buildTravelQoutationRequest(
          { travelDetails, applicants, selectedFeatures: featuresList },
          props.i18n.language,
          undefined,
          businessLine
        ),
        businessLine
      )
      .then((response) => {
        dispatch(setLoading(false));
        if (response.data.Status == "Success") {
          submitCRMCampaignApi(response.data.QuotationNumber, "TI");
          dispatch(updateTravelQuotation(response.data));
          localStorage.setItem(
            "travelQuotation",
            JSON.stringify(response.data)
          );
          setShowDiscount(true);
          // navigate("/travel/payment", { replace: true });
          navigate(
            Boolean(businessLine)
              ? `/${businessLine}/travel/payment`
              : "/travel/payment",
            { replace: true }
          );
        } else {
          toast.current.show({
            severity: "error",
            detail: response.data.ResultMessage,
          });
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };

  const isFlightProduct = () => {
    return ["FD", "TR-FD"].includes(selectedProductCode);
  };

  const isShortPeriod = () => {
    return (
      moment(travelDetails.returnDate).diff(
        moment(travelDetails.deptDate),
        "d"
      ) <= 180
    );
  };

  const formik = useFormik({
    initialValues: {
      iban: "",
      bank: "",
    },
    validate: (data) => {
      let errors = {};

      if (data.iban && !data.bank) {
        errors.bank = t("bankRequired");
      }
      if (data.bank && !data.iban) {
        errors.iban = t("ibanRequired");
      }
      // if (!data.iban) {
      //   errors.iban = t("ibanRequired");
      // }else

      if (data.iban && data.iban.length !== 22) {
        errors.iban = t("ibanNotValid");
      }
      return errors;
    },
    onSubmit: (data) => {
      console.log(data);
      if (data.iban && data.bank) {
        travelDetails["bankCode"] = data.bank;
        travelDetails["iban"] = travelDetails.ibanPrefix + data.iban;
        dispatch(updateTravelDetails(travelDetails));
      }

      goToPayment();
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const goNextHandler = () => {
    if (isFlightProduct()) {
      formik.submitForm();
    } else {
      goToPayment();
    }
  };
  const { width, height } = useWindowSize();

  const [priceArr, setPriceArr] = useState([]);

  const getPriceSummary = () =>{
    const priceTemp = [];
    let pricObject = {
      title: null,
      price: null,
      code:null,
    }
    const PriceDetails = travelProposal?.PriceDetails[0]
    for (const key in  PriceDetails) {
      if (Object.hasOwnProperty.call(PriceDetails, key)) {
        pricObject.title = key
        pricObject.code = key
        pricObject.price = PriceDetails[key]
        priceTemp.push({...pricObject})
      }
    }
    setPriceArr([...priceTemp])
  }

  useEffect(()=>{
    getPriceSummary();
  },[travelProposal])

  return (
    <TravelInsuranceDetailsStyleWrapper>
      <Toast ref={toast} />
      <Confetti width={width} height={height} run={showDiscount} />

      <div
        className={
          "container mt-5 " + (props.i18n.language === "ar" ? "ar" : "")
        }
        style={{ minHeight: "70vh" }}
      >
        <div className="row">
          <div className="col-md-3 text-initial">
            <h3>{t("Bundle-your-insurance-with-our-popular-products")} </h3>
          </div>
          <div className="col-md-9">
            <div className="row gx-3">
              <div className="col-6 col-md-3 indexing">
                <ProductCard
                  image={<TravelIcon className="check-card-icon" />}
                  detailsLabel={t("viewDetails")}
                  title={t("travel-insurance")}
                  price={travelProposal?.PriceDetails[0]?.totalPremiumWithoutDisc}
                  productCode={travelDetails.productFeatureCode}
                  isActive={
                    selectedProductCode === travelDetails.productFeatureCode
                  }
                  bundleStyle={true}
                  onSelect={(d) => setSelectedProductCode(d)}
                  onLinkClick={(x) => setShowCoverageDetails(true)}
                />
              </div>
              <div className="col-6 col-md-3">
                {/* <ProductCard
                  image={<CovidIcon className="check-card-icon" />}
                  title={t("travel-insurance") + " + " + t("COVID_INSURANCE")}
                  price={
                    getCovidBundlePrice() &&
                    features.find((f) => f.featureCode === "005")
                      ? getCovidBundlePrice()
                      : "0.00"
                  }
                  productCode="TR-CD"
                  detailsLabel={t("changeCoverage")}
                  disabled={
                    !getCovidBundlePrice() ||
                    !features.find((f) => f.featureCode === "005")
                  }
                  hideCoverageDetails={true}
                  disableDetailsBtn={disableChangeFlightDetails}
                  salePrice={disableFlight ? null : getSalesBundlePrice()}
                  badge={t("Deal")}
                  bundleStyle={true}
                  isActive={"TR-CD" === selectedProductCode}
                  onSelect={(d) => setSelectedProductCode(d)}
                  onLinkClick={(x) => updateFlightDelay(true)}
                /> */}
              </div>
              {/* <div className="col-6 col-md-3">
        <ProductCard
         image={<FlightDelayIcon className="check-card-icon" />}
         title={t("flight-delay")}
         detailsLabel={flightProposal && flightProposal.proposalCode ? t("changeCoverage") : t("enterFlightNumber")}
         disabled={disableFlight}
         disableDetailsBtn={disableChangeFlightDetails}
         price={getFlightDelayPrice()}
         isActive={"FD" === selectedProductCode}
         onSelect={(d) => setSelectedProductCode(d)}
         productCode="FD"
         bundleStyle={true}
         onLinkClick={(x) => updateFlightDelay(true)}
        />
       </div>
       <div className="col-6 col-md-3">
        <ProductCard
         image={<TravelDelayIcon className="check-card-icon" />}
         title={t("travel-insurance") + " + " + t("flight-delay")}
         price={disableFlight ? "0.00" : getPreSalesBundlePrice()}
         productCode="TR-FD"
         detailsLabel={t("changeCoverage")}
         disabled={disableFlight}
         hideCoverageDetails={true}
         disableDetailsBtn={disableChangeFlightDetails}
         salePrice={disableFlight ? null : getSalesBundlePrice()}
         badge={t("Deal")}
         bundleStyle={true}
         isActive={"TR-FD" === selectedProductCode}
         onSelect={(d) => setSelectedProductCode(d)}
         onLinkClick={(x) => updateFlightDelay(true)}
        />
       </div> */}
            </div>
          </div>
        </div>
        {features.length > 0 && !!features.map((feat) => feat.price) && isShortPeriod() && (
            <React.Fragment>
              <Divider className="my-4" />
              <div className="row">
                <div className="col-md-3">
                  <h3 className="text-initial mb-4">{props.t("addons")}</h3>
                </div>
                <div className="col-md-9">
                  <div className="row">
                    {features.map((f) => (
                      <>
                        <div key={f.featureCode} className="col-6 col-md-3 indexing">
                          <ProductCard
                            image={
                              f.featureCode === "" ? (
                                <HomeInsuranceIcon className="check-card-icon" />
                              ) : f.featureCode === "001" ? (
                                <WinterSportsIcon className="check-card-icon" />
                              ) : (
                                <CovidIcon className="check-card-icon" />
                              )
                            }
                            detailsLabel={t("viewDetails")}
                            title={f.featureDescription}
                            hideCoverageDetails={true}
                            price={vatablePriceFeature(f.price)}
                            productCode={f.featureCode}
                            onSelect={(code) => selectFeature(f)}
                            isActive={isSelectedFeature(f.featureCode)}
                            onLinkClick={(x) => setShowCoverageDetails(true)}
                            isHomeInsurance={f.isHomeInsurance}
                            changeHomeInsurance={(val) =>
                              f.changeHomeInsurance(val)
                            }
                          />
                        </div>
                      </>
                    ))}
                    {/* home */}
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}

        {isFlightProduct() && (
          <React.Fragment>
            <Divider className="my-4" />

            <div className="row">
              <div className="col-md-3">
                <h3 className="text-start mb-4">{props.t("bank-info")}</h3>
              </div>
              <div className="col-md-9">
                <form onSubmit={formik.handleSubmit} className="p-fluid row">
                  <div className="field col-6">
                    <span className="p-float-label">
                      <Dropdown
                        value={formik.values.bank}
                        name="bank"
                        id="bank"
                        className={`${classNames({
                          "p-invalid": isFormFieldValid("bank"),
                        })}`}
                        options={travelConfig.banks}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        optionLabel={
                          globalUtils.isArabic(props.i18n.language)
                            ? "nameAr"
                            : "nameEn"
                        }
                        optionValue="code"
                        placeholder={
                          <span style={{ color: "#495057" }}>
                            {props.t("bank")}
                          </span>
                        }
                      />
                    </span>
                    {getFormErrorMessage("bank")}
                  </div>
                  <div className="field col-6">
                    <span className="p-float-label">
                      <IbanInput
                        withPrefix={true}
                        id="iban"
                        name="iban"
                        placeholder={t("iban")}
                        value={formik.values.iban}
                        onChange={formik.handleChange}
                        className={classNames({
                          "p-invalid": isFormFieldValid("iban"),
                        })}
                      />
                    </span>
                    {getFormErrorMessage("iban")}
                  </div>
                </form>
              </div>
            </div>
          </React.Fragment>
        )}

        <Divider className="my-4" />

        {/* <div className="row">
     <div className="col-md-3">
      <h3 className="text-initial mb-4">{props.t("alfursan")}</h3>
     </div>
     <div className="col-md-9">
      <AlFursan onSuccess={updateAlfursanId} />
     </div>
    </div>
    <Divider className="my-4" /> */}
        <div className="row">
          <div className="col-md-3">
            <h3 className="text-initial mb-4">{props.t("promo-code")}</h3>
          </div>
          <div className="col-md-9 mb-4">
            <PromoCode
              onValidPromo={updatePromoCode}
              setPromoCodeFlag={setPromoCodeFlag}
            />
          </div>
        </div>
        {/* <div className="row mb-5">
          <div className="col-12">
            <div className="offer_wrapper">
              <div className="offer_image">
                <img src={ThumbUp} alt="celebration image" />
              </div>
              <div className="offer_desc">
                <h3 className="desc_txt1">
                  Your Free 10 days Travel Cover Activated!
                </h3>
                <h4 className="desc_txt2">
                  Since you've selected <b>10 Days</b> for your travel, as a Motor Insurance customer, you automatically qualify for free Travel Insurance for this period. Enjoy your upcoming journey with peace of mind!
                </h4>
              </div>
            </div>
          </div>
        </div> */}
        {/* <div className="row mb-5">
          <div className="col-12">
            <div className="offer_wrapper">
              <div className="offer_image">
                <img src={ThumbUp} alt="celebration image" />
              </div>
              <div className="offer_desc">
                <h3 className="desc_txt1">
                  Discount Unlocked!
                </h3>
                <h4 className="desc_txt2">
                Your travel plan extends beyond the <b>10 free days</b>. Good news! As a Motor Insurance holder, you get a special discount on additional Travel Insurance coverage for these extra days.
                </h4>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <FlightDelay
        show={showFlightDelay}
        flightProposal={flightProposal}
        flightNumber={travelDetails.flightNumber}
        departureDate={travelDetails.deptDate}
        onCancel={() => updateFlightDelay(false)}
      />
      <CoveragePopup
        show={showCoverageDetails}
        onPopupClose={() => setShowCoverageDetails(false)}
      />
      <DiscountPopup
        show={showDiscount}
        discountValue={5}
        onPopupClose={() => {
          setShowDiscount(false);
          // navigate("/travel/payment", { replace: true });
          navigate(
            Boolean(businessLine)
              ? `/${businessLine}/travel/payment`
              : "/travel/payment",
            { replace: true }
          );
        }}
      />
      <SubFooter
        priceDetails={null}
        nextBtnLabel={travelProposal?.PriceDetails[0]?.totalPremimum == "0.0" ? props.i18n.t("NEXT") :
          props.i18n.t("PAY_NOW")}
        icon={travel}
        nextBtnHandler={goNextHandler}
        showMakeChangeBtn={true}
        makeChangeLabel={props.i18n.t("MAKE_CHANGES")}
        makeChangeHandler={() =>
          navigate(
            Boolean(businessLine) ? `/${businessLine}/travel` : "/travel",
            { replace: true }
          )
        }
        hideSummary={true}
        summary={priceArr}
        total={
          "" + getTravelPrice()
          // (
          //   selectedFeatures && selectedFeatures.length
          //     ? +getTravelOriginalPrice(true)
          //     : +getTotalPrice()
          // ).toFixed(2)
        }
        beforeTotal={travelProposal?.PriceDetails[0]?.totalPremiumWithoutDisc}
      />
    </TravelInsuranceDetailsStyleWrapper>
  );
};

export default withTranslation()(TravelInsuranceDetails);
